class ProductDescriptionTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-product-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-product-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab.dataset.productTab));
    });
  }

  selectTab(target) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.productTab === target;

      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.productPanel === target;

      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

if (!customElements.get('product-description-tabs')) {
  customElements.define('product-description-tabs', ProductDescriptionTabs);
}
